import React from 'react';
import { Link, useTheme } from '@material-ui/core';
import { TaxiCompanyList } from '../../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { useCautionStyles } from '../Cautions';

interface Props {
  /** 仮予約画面で表示するタクシー会社名 */
  companyDisplayName: string,
  /** タクシー会社 */
  company: TaxiCompanyList
}

/** AMCマイレージ番号に関する注意事項 */
export const AMCCautionEN: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  const classes = useCautionStyles(theme);

  const taxiMileHelpURL = "https://www.ana.co.jp/ja/jp/site-help/share/contact/mileage_top.html";
  return (
    <>
      <span className={classes.bold}>&lt; Notes on Miles (please make sure to confirm) &gt;</span>
      <ul className={classes.unorderedList} data-cy={"booking_taxi_amccaution_en"}>
        <li>
          If you book, ride and complete payment with the limousine or taxi operating company after entering your 10-digit ANA Mileage Club membership number on this screen, one mile will be added to your mileage for every JPY 200 (including tax) paid. No miles will be added in other cases.
        </li>
        <li>
          One mile will be added to your mileage separately for every JPY 200 (including tax) paid for payments made using an ANA card.
        </li>
        <li>
          Approximately 1-2 months will be required for the miles to be credited to the mileage balance. The timing is different to the addition of miles due to payment with an ANA card.
        </li>
        <li>
          If you cancel a booking after it has been confirmed, no miles will be added. In addition, change and cancellation processing fees are not subject to the addition of miles.
        </li>
        <li>
          If the entered ANA Mileage Club membership number and name differ, no miles will be added.
        </li>
        <li>
          Please be careful when making a booking as we are unable to accept corrections to an ANA Mileage Club membership number after a booking is confirmed or ex-post registrations.
        </li>
        <li>
          For inquiries about the ANA Mileage Club, click <Link href={taxiMileHelpURL} target="_blank" className={classes.link}>here</Link>.
        </li>
      </ul>
    </>
  )
}

export default AMCCautionEN;
